import React, { useEffect, useState } from "react";
import logo from "../asico.png";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import axios from "axios";
import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import FileDownload from "@mui/icons-material/FileDownload";
import dayjs from "dayjs";
dayjs.locale("th");

export async function export_cpl(
  dataExport,
  allTorelance,
  allTorelance2,
  formatTorelance,
  allSpecCount
) {
  const axiosToken = () => {
    return {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("QCAPPjwt"),
      },
    };
  };
  console.log(allTorelance, allTorelance2, formatTorelance);

  const workbook = new ExcelJS.Workbook({ useStyle: true });
  const worksheet = workbook.addWorksheet("sheet", {
    pageSetup: {
      paperSize: 9,
      orientation: "portrait",
      scale: 90,
      fitToPage: 1,
      horizontalCentered: true,
      margins: {
        left: 0.0,
        right: 0.0,
        top: 0.4,
        bottom: 0.0,
        header: 0.0,
        footer: 0.0,
      },
    },
  });

  if (allSpecCount) {
    for (let i = 0; i < allSpecCount.length; i++) {
      let col = 4 + 2 * i;
      const cellAddress = `${String.fromCharCode(64 + col)}20`;
      const cell = worksheet.getCell(cellAddress);
      console.log(col, allSpecCount[i]);
      cell.value = allSpecCount[i];
    }
  }
  if (allTorelance && allTorelance2 && formatTorelance === "plusPlus") {
    for (let i = 0; i < allTorelance.length; i++) {
      let col = 4 + 2 * i;
      const cellAddress1 = `${String.fromCharCode(64 + col)}21`;
      const cellAddress2 = `${String.fromCharCode(64 + col)}22`;
      const cell1 = worksheet.getCell(cellAddress1);
      cell1.value = allTorelance[i];
      const cell2 = worksheet.getCell(cellAddress2);
      cell2.value = allTorelance2[i];
    }
  }

  if (allTorelance && allTorelance2 && formatTorelance === "plusMinus") {
    for (let i = 0; i < allTorelance.length; i++) {
      let col = 4 + 2 * i;
      const cellAddress1 = `${String.fromCharCode(64 + col)}21`;
      const cellAddress2 = `${String.fromCharCode(64 + col)}22`;
      const cell1 = worksheet.getCell(cellAddress1);
      cell1.value = allTorelance[i];
      const cell2 = worksheet.getCell(cellAddress2);
      cell2.value = -allTorelance2[i];
    }
  }

  if (allTorelance && allTorelance2 && formatTorelance === "minusMinus") {
    for (let i = 0; i < allTorelance.length; i++) {
      let col = 4 + 2 * i;
      const cellAddress1 = `${String.fromCharCode(64 + col)}21`;
      const cellAddress2 = `${String.fromCharCode(64 + col)}22`;
      const cell1 = worksheet.getCell(cellAddress1);
      cell1.value = -allTorelance[i];
      const cell2 = worksheet.getCell(cellAddress2);
      cell2.value = -allTorelance2[i];
    }
  }
  ////ADJUST comlumn "1" to minimize
  worksheet.getColumn(1).width = 0;
  ////////////

  let font = { name: "CordiaUPC", size: 16 };

  if (logo) {
    const imageBuffer = await axios.get(logo, {
      responseType: "arraybuffer",
    });
    const image_logo = workbook.addImage({
      buffer: imageBuffer.data,
      extension: "png",
    });
    worksheet.addImage(image_logo, {
      tl: { col: 1.5, row: 1.5 },
      br: { col: 3, row: 4.2 },
    });
  }

  if (dataExport.imagePart !== null) {
    const imagePartBuffer = await axios.get(dataExport.imagePart, {
      responseType: "arraybuffer",
    });
    const image_part = workbook.addImage({
      buffer: imagePartBuffer.data,
      extension: "png",
    });
    worksheet.addImage(image_part, {
      tl: { col: 10, row: 3.5 },
      br: { col: 18, row: 17 },
    });
  }

  if (dataExport.signature_approver !== null) {
    console.log(dataExport);
    const image_signature_approver_buffer = await axios.get(
      dataExport.signature_approver,
      {
        responseType: `arraybuffer`,
      }
    );
    const image_signature_approver = workbook.addImage({
      buffer: image_signature_approver_buffer.data,
      extension: `png`,
    });
    worksheet.addImage(image_signature_approver, {
      tl: { col: 13.3, row: 64.2 },
      br: { col: 14.8, row: 66.5 },
    });
  }

  if (dataExport.signature_checker !== null) {
    const image_signature_checker_buffer = await axios.get(
      dataExport.signature_checker,
      {
        responseType: "arraybuffer",
      }
    );
    const image_signature_checker = workbook.addImage({
      buffer: image_signature_checker_buffer.data,
      extension: "png",
    });
    worksheet.addImage(image_signature_checker, {
      tl: { col: 15.3, row: 64.2 }, // top-left corner at the start of B5
      br: { col: 16.8, row: 66.5 },
    });
  }

  /////////CONTENT IN LOGO ///////////////
  worksheet.getCell("B6").value = "Cust. :";
  worksheet.getCell("B7").value = "Model. :";
  worksheet.getCell("B8").value = "P/no.  :";
  worksheet.getCell("B9").value = "P/name.  :";
  worksheet.getCell("B10").value = "Event  :";

  worksheet.mergeCells("B1:S1");
  const valueHeader = worksheet.getCell("B1");
  valueHeader.value = "PROCESS CAPABILITY INDEX";
  valueHeader.style = {
    alignment: {
      vertical: "middle",
      horizontal: "center",
    },
    font: {
      name: "Cordia UPC",
      bold: true,
      size: 18,
    },
    fill: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFF803" }, // Correct ARGB format with alpha component
    },
  };
  for (let col = 3; col <= 16; col++) {
    if (col == 16) {
      const cell = worksheet.getCell(1, 16);
      cell.border = {
        top: { style: "thin" },
        right: { style: "thin" },
      };
    } else {
      const cell = worksheet.getCell(1, col);
      cell.border = {
        top: { style: "thin" },
      };
      // }
    }
  }

  worksheet.getCell("S2").border = {
    right: { style: "thin" },
  };

  ///Drawing Sketch
  worksheet.mergeCells("J2:S2");
  let cols = ["K2", "L2", "M2", "N2", "O2", "P2", "Q2", "R2", "S2"];
  ///Drawing Sketch
  cols.forEach((col) => {
    worksheet.getCell(`${col}`).style = {
      border: {
        bottom: { style: "thin" },
        top: { style: "thin" },
        right: { style: "thin" },
        // left: { style: "thin" },
      },
    };
  });

  worksheet.getCell("S18").style = {
    border: {
      bottom: { style: "thin" },
      right: { style: "thin" },
    },
  };

  let cols1 = [
    // "B18",
    // "C18",
    // "D18",
    // "E18",
    // "F18",
    // "G18",
    // "H18",
    // "I18",
    "J18",
    "K18",
    "L18",
    "M18",
    "N18",
    "O18",
    "P18",
    "Q18",
    "R18",
    // "S18",
  ];
  cols1.forEach((col) => {
    const celDirectly = (worksheet.getCell(`${col}`).style = {
      border: {
        bottom: { style: "thin" },
      },
    });
  });

  //Drawing /////Sketch
  const startCell = worksheet.getCell("J2");
  // const endCell = worksheet.getCell("S2");
  // endCell.style = {
  //   border: {
  //     bottom: { style: "thin" },
  //     left: { style: "thin" },
  //     right: { style: "thin" },
  //     top: { style: "thin" },
  //   },
  // };
  startCell.value = "DRAWING / SKETCH";
  startCell.style = {
    border: {
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
      top: { style: "thin" },
    },
    alignment: {
      vertical: "middle",
      horizontal: "center",
    },
    font: {
      size: 18,
      name: "CordiaUPC",
    },
  };

  //CHECK CONDITION
  worksheet.mergeCells("F2:I2");
  worksheet.getCell("F2").value = "CHECK CONDITION";
  worksheet.getCell("F2").style = {
    alignment: {
      vertical: "middle",
      horizontal: "center",
    },
    border: {
      bottom: { style: "thin" },
      top: { style: "thin" },
      left: { style: "thin" },
      // right: { style: "thin" }
    },
    fill: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFBB00" }, //ffffbb00
    },
  };
  let cols2 = ["G2", "H2", "I2"];
  cols2.forEach((col) => {
    worksheet.getCell(`${col}`).style = {
      border: {
        bottom: { style: "thin" },
        top: { style: "thin" },
      },
    };
  });
  let cols4 = ["C2", "D2", "E2"];
  cols4.forEach((col) => {
    worksheet.getCell(`${col}`).style = {
      border: {
        // bottom: { style: "thin" },
        top: { style: "thin" },
      },
    };
  });
  worksheet.getCell("E11").border = {
    right: { style: "thin" },
  };
  //Body check condition
  let cols3 = ["F3", "F4", "F5", "F6", "F7", "F8", "F9"];
  cols3.forEach((col) => {
    worksheet.getCell(`${col}`).style = {
      border: {
        left: { style: "thin" },
      },
    };
  });

  let cols5 = ["G10", "H10"];
  cols5.forEach((col) => {
    worksheet.getCell(`${col}`).style = {
      border: {
        bottom: { style: "thin" },
      },
    };
  });
  worksheet.getCell("F10").style = {
    border: {
      bottom: { style: "thin" },
      left: { style: "thin" },
    },
  };
  worksheet.getCell("I10").style = {
    border: {
      bottom: { style: "thin" },
      right: { style: "thin" },
    },
  };
  //Content Condtion
  worksheet.mergeCells("F3:I3");
  const toolDie = worksheet.getCell("F3");
  toolDie.value = "☐   Tool/ Die change.";
  toolDie.style = {
    alignment: {
      vertical: "middle",
      horizontal: "left",
    },
    border: {
      left: { style: "thin" },
      // right: { style: "thin" },
    },
    font: font,
  };

  worksheet.mergeCells("F4:I4");
  const processDesgin = worksheet.getCell("F4");
  processDesgin.value = "☐   Process desgin / Layout change.";
  processDesgin.style = {
    alignment: {
      vertical: "middle",
      horizontal: "left",
    },
    border: {
      left: { style: "thin" },
      // right: { style: "thin" },
    },
    font: font,
  };
  worksheet.mergeCells("F5:I5");
  const newModel = worksheet.getCell("F5");
  newModel.value = "☐   New model /New part.";
  newModel.style = {
    alignment: {
      vertical: "middle",
      horizontal: "left",
    },
    border: {
      left: { style: "thin" },
      right: { style: "thin" },
    },
    font: font,
  };
  worksheet.mergeCells("F6:I6");
  const firstProduct = worksheet.getCell("F6");
  firstProduct.value = "☐   First product .";
  firstProduct.style = {
    alignment: {
      vertical: "middle",
      horizontal: "left",
    },
    border: {
      //   bottom: { style: "dashed", color: { argb: "FF000000" } },
      left: { style: "thin" },
      right: { style: "thin" },
    },
    font: font,
  };
  worksheet.mergeCells("F7:I7");
  const material_machine = worksheet.getCell("F7");
  material_machine.value = "☐   Material / Machine change.";
  material_machine.style = {
    alignment: {
      vertical: "middle",
      horizontal: "left",
    },
    border: {
      left: { style: "thin" },
      right: { style: "thin" },
    },
    font: font,
  };
  worksheet.mergeCells("F8:I8");
  const normalCheck = worksheet.getCell("F8");
  normalCheck.value = "☐   Normal check.";
  normalCheck.style = {
    alignment: {
      vertical: "middle",
      horizontal: "left",
    },
    border: {
      left: { style: "thin" },
      right: { style: "thin" },
    },
    font: font,
  };

  worksheet.mergeCells("F9:I9");
  const other = worksheet.getCell("F9");
  other.value = "☐  Other.";
  other.style = {
    alignment: {
      vertical: "middle",
      horizontal: "left",
    },
    border: {
      left: { style: "thin" },
      right: { style: "thin" },
    },
    font: font,
  };

  //Detail Content
  worksheet.mergeCells("F11:I11");
  const detailHeader = worksheet.getCell("F11");
  detailHeader.value = "Detail :";

  //Standard for Judgement
  worksheet.mergeCells("B12:E13");
  worksheet.getCell("B12").value = "Standard for Judgement"; // Set value
  worksheet.getCell("B12").alignment = {
    horizontal: "center",
    vertical: "middle",
  };
  worksheet.getCell("B12").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFFFBB00" }, //ffffbb00
  };
  worksheet.getCell("B12").font = font;

  ///item
  worksheet.mergeCells("B14:C14");
  worksheet.getCell("B14").value = "Item"; // Set value
  worksheet.getCell("B14").alignment = {
    horizontal: "center",
    vertical: "middle",
  };
  worksheet.getCell("B14").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFFFBB00" }, //ffffbb00
  };
  worksheet.getCell("B14").font = font;

  worksheet.mergeCells("B15:C16");
  worksheet.getCell("B15").value = "New Part";
  worksheet.getCell("B15").alignment = {
    horizontal: "left",
    vertical: "middle",
  };
  worksheet.getCell("B15").font = font;

  worksheet.mergeCells("B17:C18");
  worksheet.getCell("B17").value = "Current Part";
  worksheet.getCell("B17").alignment = {
    horizontal: "left",
    vertical: "middle",
  };
  worksheet.getCell("B17").font = font;

  //Capability Value
  worksheet.mergeCells("D14:E14");
  worksheet.getCell("D14").value = "Capability Value"; // Set value
  worksheet.getCell("D14").alignment = {
    horizontal: "center",
    vertical: "middle",
  };
  worksheet.getCell("D14").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFFFBB00" }, //ffffbb00
  };
  worksheet.getCell("D14").font = font;

  worksheet.mergeCells("D15:E16");
  worksheet.getCell("D15").value = "         ";
  worksheet.getCell("D15").border = {
    left: { style: "thin" },
    right: { style: "thin" },
  };
  // worksheet.getCell("D14").border = {
  //   left: { style: "thin" },
  //   right: { style: "thin" },
  // };

  worksheet.getCell("D15").alignment = {
    horizontal: "left",
    vertical: "middle",
  };

  worksheet.mergeCells("D17:E18");
  worksheet.getCell("D17").value = "         ";
  worksheet.getCell("D17").border = {
    left: { style: "thin" },
    right: { style: "thin" },
    bottom: { style: "thin" },
  };
  worksheet.getCell("D17").alignment = {
    horizontal: "left",
    vertical: "middle",
  };

  ///Inspection Item
  worksheet.mergeCells("B19:C19");
  worksheet.getCell("B19").value = "Inspection Item";
  worksheet.getCell("B19").alignment = {
    horizontal: "left",
    vertical: "middle",
  };
  worksheet.getCell("B19").font = font;

  /// Spec Cont
  worksheet.mergeCells("B20:C20");
  worksheet.getCell("B20").value = "Spec Cont.";
  worksheet.getCell("B20").alignment = {
    horizontal: "left",
    vertical: "middle",
  };
  worksheet.getCell("B20").font = font;

  worksheet.mergeCells("B21:C22");
  worksheet.getCell("B21").value = "Tolerance";
  worksheet.getCell("B21").alignment = {
    horizontal: "left",
    vertical: "middle",
  };
  worksheet.getCell("B21").font = font;

  worksheet.mergeCells("B23:C23");
  worksheet.getCell("B23").value = "No. /Tool No.";
  worksheet.getCell("B23").alignment = {
    horizontal: "left",
    vertical: "middle",
  };
  worksheet.getCell("B23").font = font;

  for (let i = 0; i < 30; i++) {
    const row = 24 + i;
    const range = `B${row}:C${row}`;
    worksheet.mergeCells(range);
    const eachRow = worksheet.getRow(row);
    eachRow.height = 26;
    const cell = worksheet.getCell(`B${row}`);
    cell.value = i + 1;
    cell.alignment = {
      horizontal: "center",
      vertical: "middle",
    };
    cell.font = {
      name: "CordiaUPC",
      size: 14,
    };
  }

  worksheet.getCell("D59").style = {
    border: {
      bottom: { style: "thin " },
    },
  };

  worksheet.mergeCells("B54:C54");

  worksheet.getCell("B54").style = {
    border: {
      top: { style: "thin " },
      right: { style: "thin" },
    },
  };
  worksheet.mergeCells("B55:C55");
  worksheet.mergeCells("B56:C56");

  worksheet.getCell("B55").value = "MINIMUM";
  worksheet.getCell("B55").alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  worksheet.mergeCells("B57:C57");

  worksheet.getCell("B56").value = "MAXIMUM";
  worksheet.getCell("B56").alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  worksheet.mergeCells("B58:C58");

  worksheet.getCell("B57").value = "AVERAGE";
  worksheet.getCell("B57").alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  worksheet.mergeCells("B59:C59");

  worksheet.getCell("B58").value = "STDEV";
  worksheet.getCell("B58").alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  ///"☐   Tool/ Die change.";
  worksheet.mergeCells("B60:C60");

  worksheet.getCell("B59").value = "☐ Cpl";
  worksheet.getCell("B59").alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  // worksheet.getCell("B60").value = "k";
  // worksheet.getCell("B60").alignment = {
  //   horizontal: "center",
  //   vertical: "middle",
  // };

  worksheet.mergeCells("B61:C61");
  // worksheet.getCell("B61").value = "☐ Cpk ☐ Ppk";
  // worksheet.getCell("B61").alignment = {
  //   horizontal: "center",
  //   vertical: "middle",
  // };

  worksheet.mergeCells("B62:C62");
  worksheet.getCell("B60").value = "JUDGEMENT";
  worksheet.getCell("B60").alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  worksheet.mergeCells("B63:J63");
  worksheet.getCell("B63").value =
    "REMARK : -this format for tolerance both side same & torelance both side not same";
  worksheet.getCell("B63").alignment = {
    horizontal: "left",
    vertical: "middle",
  };

  worksheet.mergeCells("L63:M63");
  worksheet.getCell("L63").value = "JUDGEMENT";
  worksheet.getCell("L63").alignment = {
    horizontal: "center",
    vertical: "middle",
  };
  worksheet.getCell("L63").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF98FB98" },
  };

  worksheet.mergeCells("N63:O63");

  worksheet.getCell("N63").value = "Approved";
  worksheet.getCell("N63").alignment = {
    horizontal: "center",
    vertical: "middle",
  };
  worksheet.getCell("N63").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF98FB98" },
  };

  worksheet.mergeCells("P63:Q63");
  worksheet.getCell("P63").value = "Checked";
  worksheet.getCell("P63").alignment = {
    horizontal: "center",
    vertical: "middle",
  };
  worksheet.getCell("P63").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF98FB98" },
  };

  worksheet.mergeCells("R63:S63");
  worksheet.getCell("R63").value = "Issued";
  worksheet.getCell("R63").alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  worksheet.getCell("R63").fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF98FB98" },
  };

  for (let i = 59; i <= 62; i++) {
    for (let col = 2; col <= 19; col++) {
      const cell = worksheet.getCell(`${String.fromCharCode(64 + col)}${i}`);
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF98FB98" },
      };
    }
  }

  worksheet.mergeCells("L64:M67");
  worksheet.getCell("L64").value = "";
  worksheet.getCell("L64").alignment = {
    horizontal: "center",
    vertical: "middle",
  };

  ///  For support Signature Approved
  worksheet.mergeCells("N64:O67");
  worksheet.mergeCells("P64:Q67");
  worksheet.mergeCells("R64:S67");

  // worksheet.getCell("R64").border = {
  //   right: { style: "thin" },
  // };

  ///Determine  Row height
  for (let i = 3; i <= 10; i++) {
    worksheet.getRow(i).height = 26;
  }

  for (let i = 55; i <= 62; i++) {
    worksheet.getRow(i).height = 28;
  }
  worksheet.getRow("61").height = 1;
  worksheet.getRow("62").height = 1;
  worksheet.getRow("63").height = 25;
  worksheet.getRow("64").height = 25;
  worksheet.getRow("19").height = 35;
  worksheet.getRow("20").height = 25;
  worksheet.getRow("21").height = 25;
  worksheet.getRow("22").height = 25;
  worksheet.getRow("23").height = 25;
  /// Draw Outer Line
  const borderStyleBottom = {
    bottom: { style: "thin" },
  };

  const borderStyleRight = {
    right: { style: "thin", color: { argb: "000000" } },
  };

  const borderStyleLeft = {
    left: { style: "thin", color: { argb: "000000" } },
  };
  const borderStyleTop = {
    top: { style: "thin", color: { argb: "000000" } }, // Specify the top border
  };

  const borderStyleBottomandRight = {
    bottom: { style: "thin", color: { argb: "000000" } },
    right: { style: "thin", color: { argb: "000000" } }, // Specify the top border
  };

  const borderStyleLeftandBottom = {
    bottom: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } }, // Specify the top border
  };

  const borderStyleLeftandTop = {
    top: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } }, // Specify the top border
  };

  const borderStyleLeftandRight = {
    right: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } }, // Specify the top border
  };

  const borderStyleLeftRightTop = {
    top: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } },
    right: { style: "thin", color: { argb: "000000" } }, // Specify the top border
  };

  const borderStyleLeftRightBottom = {
    bottom: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } },
    right: { style: "thin", color: { argb: "000000" } }, // Specify the top border
  };

  for (let col = 2; col <= 5; col++) {
    const cell = worksheet.getCell(12, col); // Get the cell at row 65 and column col
    cell.border = borderStyleTop;
  }

  for (let col = 2; col <= 18; col++) {
    const cell = worksheet.getCell(53, col);
    cell.border = {
      bottom: { style: "thin" },
      right: { style: "thin" },
      left: { style: "thin" },
    };
  }

  worksheet.getCell("S53").border = {
    bottom: { style: "thin" },
    right: { style: "thin" },
  };

  worksheet.getCell("S55").border = {
    top: { style: "thin" },
    right: { style: "thin" },
  };

  worksheet.getCell("S61").border = {
    // top: { style: "thin" },
    right: { style: "thin" },
  };

  worksheet.getCell("S62").border = {
    right: { style: "thin" },
  };
  worksheet.getCell("R62").border = {
    right: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
  };

  worksheet.getCell("S63").border = {
    right: { style: "thin" },
    bottom: { style: "thin" },
  };
  worksheet.getCell("N63").border = {
    right: { style: "thin" },
    bottom: { style: "thin" },
    left: { style: "thin" },
  };
  worksheet.getCell("P63").border = {
    right: { style: "thin" },
    bottom: { style: "thin" },
    // left: { style: "thin" },
  };

  worksheet.getCell("L63").border = {
    left: { style: "thin" },
    bottom: { style: "thin" },
  };
  worksheet.getCell("L64").border = {
    left: { style: "thin" },
    // bottom: { style: "thin" },
  };

  worksheet.getCell("S67").border = borderStyleBottomandRight;
  worksheet.getCell("B67").border = borderStyleLeftandBottom;

  worksheet.getCell("G18").border = borderStyleBottom;
  worksheet.getCell("F18").border = borderStyleBottom;
  worksheet.getCell("H18").border = borderStyleBottom;
  worksheet.getCell("I18").border = borderStyleBottomandRight;

  // mrege cell

  for (let i = 19; i <= 53; i++) {
    worksheet.mergeCells(`D${i}:E${i}`);
  }
  for (let i = 55; i <= 62; i++) {
    worksheet.mergeCells(`D${i}:E${i}`);
  }
  for (let i = 19; i <= 53; i++) {
    worksheet.mergeCells(`F${i}:G${i}`);
  }
  for (let i = 55; i <= 62; i++) {
    worksheet.mergeCells(`F${i}:G${i}`);
  }

  for (let i = 19; i <= 53; i++) {
    worksheet.mergeCells(`H${i}:I${i}`);
  }
  for (let i = 55; i <= 62; i++) {
    worksheet.mergeCells(`H${i}:I${i}`);
  }
  for (let i = 19; i <= 53; i++) {
    worksheet.mergeCells(`J${i}:K${i}`);
  }
  for (let i = 55; i <= 62; i++) {
    worksheet.mergeCells(`J${i}:K${i}`);
  }
  for (let i = 19; i <= 53; i++) {
    worksheet.mergeCells(`L${i}:M${i}`);
  }
  for (let i = 55; i <= 62; i++) {
    worksheet.mergeCells(`L${i}:M${i}`);
  }

  for (let i = 19; i <= 53; i++) {
    worksheet.mergeCells(`N${i}:O${i}`);
  }
  for (let i = 55; i <= 62; i++) {
    worksheet.mergeCells(`N${i}:O${i}`);
  }

  for (let i = 19; i <= 53; i++) {
    worksheet.mergeCells(`P${i}:Q${i}`);
  }
  for (let i = 55; i <= 62; i++) {
    worksheet.mergeCells(`P${i}:Q${i}`);
  }

  for (let i = 19; i <= 53; i++) {
    worksheet.mergeCells(`R${i}:S${i}`);
  }

  for (let i = 55; i <= 62; i++) {
    worksheet.mergeCells(`R${i}:S${i}`);
  }
  for (let i = 19; i <= 52; i++) {
    const each = worksheet.getCell(`G${i}`);
    each.border = borderStyleRight;
  }

  for (let i = 19; i <= 52; i++) {
    const each = worksheet.getCell(`J${i}`);
    each.border = borderStyleRight;
  }

  for (let i = 19; i <= 52; i++) {
    const each = worksheet.getCell(`L${i}`);
    each.border = borderStyleRight;
  }

  for (let i = 19; i <= 52; i++) {
    const each = worksheet.getCell(`N${i}`);
    each.border = borderStyleRight;
  }

  for (let i = 19; i <= 52; i++) {
    const each = worksheet.getCell(`P${i}`);
    each.border = borderStyleRight;
  }
  // Last line
  for (let col = 3; col <= 11; col++) {
    const cell = worksheet.getCell(67, col);
    cell.border = borderStyleBottom;
  }

  for (let col = 11; col <= 17; col++) {
    const cell = worksheet.getCell(67, col);
    cell.border = borderStyleBottomandRight;
  }

  for (let i = 64; i <= 66; i++) {
    const cell = worksheet.getCell(`K${i}`);
    cell.border = borderStyleRight;
  }

  /// Sperate Line body and foooter
  for (let col = 2; col <= 19; col++) {
    const cell = worksheet.getCell(55, col);
    cell.border = borderStyleLeftandTop;
  }

  for (let col = 2; col <= 19; col++) {
    const cell = worksheet.getCell(55, col);
    cell.border = borderStyleLeftandTop;
  }

  /////////////
  for (let col = 56; col <= 66; col++) {
    if (col == 62) {
      continue;
    }
    const cell = worksheet.getCell(`B${col}`);
    cell.border = borderStyleLeft;
  }

  worksheet.getCell("B62").border = {
    bottom: { style: "thin" },
    left: { style: "thin" },
  };
  ////////////

  for (let i = 3; i <= 17; i++) {
    const cell = worksheet.getCell(`S${i}`);
    cell.border = borderStyleRight;
  }

  for (let i = 19; i <= 52; i++) {
    const cell = worksheet.getCell(`S${i}`);
    cell.border = borderStyleRight;
  }

  for (let i = 2; i <= 52; i++) {
    const cell = worksheet.getCell(`B${i}`);
    if (i >= 24 && i % 3 == 0) {
      cell.border = borderStyleLeftandTop;
    }
    // if (i == 1) {
    //   cell.border = {
    //     left: { style: "thin" },
    //     bottom: { style: "thin" },
    //     top: { style: "thin" },
    //   };
    else {
      cell.border = borderStyleLeft;
    }
  }
  worksheet.getCell("B1").border = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
  };

  worksheet.getCell("B14").border = {
    top: { style: "thin" },
    left: { style: "thin" },
  };

  worksheet.getCell("D14").border = {
    top: { style: "thin" },
    right: { style: "thin" },
    left: { style: "thin" },
  };

  worksheet.getCell("B12").border = {
    top: { style: "thin" },
    right: { style: "thin" },
    left: { style: "thin" },
  };

  for (let i = 19; i <= 52; i++) {
    const cell = worksheet.getCell(`D${i}`);
    if (i >= 23 && i % 3 == 0) {
      continue;
    } else {
      // cell.border = borderStyleLeft;
    }
  }

  //Middle Line of Paper
  for (let i = 3; i <= 53; i++) {
    const cell = worksheet.getCell(`I${i}`);
    if (i == 18 || i == 10 || i == 53) {
      continue;
    } else {
      cell.border = borderStyleRight;
    }
  }

  for (let i = 56; i <= 61; i++) {
    for (let j = 4; j <= 19; j++) {
      if (j == 19) {
        const cell = worksheet.getCell(`${String.fromCharCode(64 + j)}${i}`);
        cell.border = borderStyleLeftandRight;
      } else {
        const cell = worksheet.getCell(`${String.fromCharCode(64 + j)}${i}`);
        cell.border = borderStyleLeft;
      }
    }
  }

  for (let col = 2; col <= 19; col++) {
    if ((col = 19)) {
      const cell = worksheet.getCell(55, col);
      cell.border = borderStyleLeftRightTop;
    } else {
      const cell = worksheet.getCell(55, col);
      cell.border = borderStyleLeftandTop;
    }
  }

  for (let col = 5; col <= 16; col++) {
    const cell = worksheet.getCell(62, col);
    cell.border = borderStyleLeftandBottom;
    // }
  }

  for (let i = 19; i <= 52; i++) {
    const cell = worksheet.getCell(`E${i}`);
    // if ((i = 14)) {
    //   cell.border = borderStyleLeftandRight;
    // } else {
    cell.style = {
      border: {
        right: { style: "thin" },
        // left: { style: "thin" },
      },
    };
    // }
  }

  for (let i = 19; i <= 52; i++) {
    const cell = worksheet.getCell(`D${i}`);
    // if ((i = 14)) {
    //   cell.border = borderStyleLeftandRight;
    // } else {
    cell.style = {
      border: {
        // right: { style: "thin" },
        left: { style: "thin" },
      },
    };
    // }
  }

  //alignement inner table

  for (let i = 19; i <= 62; i++) {
    for (let j = 4; j <= 19; j++) {
      const cell = worksheet.getCell(`${String.fromCharCode(64 + j)}${i}`);
      cell.alignment = {
        vertical: "middle",
        horizontal: "center",
      };
    }
  }

  if (dataExport.dataquestion != null) {
    const getAnswer = dataExport.dataquestion;
    console.log(getAnswer.length);

    let rowIndex = 24; // Starting row
    let startColumnIndex = 4; //startColumn
    for (let i = 0; i < getAnswer.length; i++) {
      let column = startColumnIndex + i * 2;
      let columnLetter = getColumnLetter(column);
      for (let j = 0; j <= getAnswer[0].actual1.length; j++) {
        let cellAddress = `${columnLetter}${rowIndex + j}`;
        const eachData = worksheet.getCell(cellAddress);
        eachData.value = getAnswer[i].actual1[j];
      }
      let checkPartName = worksheet.getCell(`${columnLetter}19`);
      if (!checkPartName.value) {
        const partName = worksheet.getCell(`${columnLetter}19`);
        partName.value = getAnswer[i].checkPoint;
      }
      let checkCellMaxMin = worksheet.getCell(`${columnLetter}55`);
      if (!checkCellMaxMin.value) {
        const maxCell = worksheet.getCell(`${columnLetter}56`);
        const minCell = worksheet.getCell(`${columnLetter}55`);
        maxCell.value = getAnswer[i].spec_max;
        minCell.value = getAnswer[i].spec_min;
      }
      let averageValue = worksheet.getCell(`${columnLetter}57`);
      averageValue.numFmt = "0.00";
      averageValue.value = {
        formula: `AVERAGE(${columnLetter}24:${columnLetter}54)`,
      };
      let stdDevValue = worksheet.getCell(`${columnLetter}58`);
      stdDevValue.numFmt = "0.00";
      stdDevValue.value = {
        formula: `STDEV(${columnLetter}24:${columnLetter}54)`,
      };
      let cpValue = worksheet.getCell(`${columnLetter}59`);
      cpValue.numFmt = "0.00";
      cpValue.value = {
        formula: `(${columnLetter}21+${columnLetter}22)/(6*${columnLetter}58)`,
      };

      let judement = worksheet.getCell(`${columnLetter}60`);
      judement.alignment = { horizontal: "center", vertical: "middle" };
      judement.numFmt = "0.00";
      judement.value = {
        formula: `IF((${columnLetter}59>=1.67),"О","X")`,
      };
    }
  }

  worksheet.getCell("L64").value = {
    formula: `IF((@D60:S60>=1.67),"О","X")`,
  };
  worksheet.getCell("L64").font = {
    size: 20,
  };

  function getColumnLetter(index) {
    let letter = "";
    let tempIndex = index - 1;
    while (tempIndex >= 0) {
      letter = String.fromCharCode((tempIndex % 26) + 65) + letter;
      tempIndex = Math.floor(tempIndex / 26) - 1;
    }
    return letter;
  }

  ///Formula Equataion

  await workbook.xlsx.writeBuffer().then((res) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([res], { type: fileType });
    saveAs(
      blob,
      `${dataExport.partName + "_CPL_" + dayjs().format("DD/MM/YYYY")}` +
        fileExtension
    );
  });
}
const ExportCPKSheet = ({ data, isReady }) => {
  const [disabled, setDisabled] = useState(true);

  return (
    <div className="App">
      <Button
        // style={{ padding: "10px", margin: "5px" }}
        disabled={disabled}
        onClick={() => export_cpl(data)}
        variant="outlined"
        endIcon={<Icon isReady={isReady} setDisabled={setDisabled} />}
      >
        download
      </Button>
    </div>
  );
};

export default ExportCPKSheet;

const Icon = ({ isReady, setDisabled }) => {
  if (isReady === undefined) {
    setDisabled(false);
    return <FileDownload />;
  } else {
    if (isReady) {
      setDisabled(false);
      return <FileDownload />;
    } else {
      setDisabled(true);
      return <CircularProgress size={20} />;
    }
  }
};
